import { useState } from "react"
import { Dashboard } from "@/components/dashboard"
import { Transactions } from "@/components/transactions"
import { Statistics } from "@/components/statistics"
import { Growth } from "@/components/growth"
import { Budget } from "@/components/budget"
import { AddExpense } from "@/components/add-expense"
import { BottomNav } from "@/components/bottom-nav"
import { Cards } from "@/components/cards"
import { Categories } from "@/components/categories"
import { SmartScanner } from "@/components/smart-scanner"
import { Settings } from "@/components/settings"
import { Profile } from "@/components/profile"
import { About } from "@/components/about"
import { RecurringTransactions } from "@/components/recurring-transactions"
import { SubAccounts } from "@/components/sub-accounts"
import { ScrollToTop } from "@/components/scroll-to-top"
import { AccountSelectionProvider } from "@/lib/context/account-selection-context"

export default function HomePage() {
  const [activeTab, setActiveTab] = useState("home")
  const [showAddExpense, setShowAddExpense] = useState(false)

  const handleNavigate = (view: string) => {
    setActiveTab(view)
  }

  return (
    <AccountSelectionProvider>
      <main className="min-h-screen bg-background pb-20">
        <div className="mx-auto max-w-md">
          {activeTab === "home" && (
            <Dashboard
              onAddExpense={() => setShowAddExpense(true)}
              onViewAllTransactions={() => setActiveTab("transactions")}
              onNavigate={handleNavigate}
            />
          )}
          {activeTab === "budget" && <Budget onNavigate={handleNavigate} />}
          {activeTab === "statistics" && <Statistics onNavigate={handleNavigate} />}
          {activeTab === "growth" && <Growth onNavigate={handleNavigate} />}
          {activeTab === "transactions" && <Transactions onNavigate={handleNavigate} />}
          {activeTab === "cards" && <Cards onBack={() => setActiveTab("home")} />}
          {activeTab === "categories" && <Categories onBack={() => setActiveTab("home")} />}
          {activeTab === "scan-document" && <SmartScanner onBack={() => setActiveTab("home")} />}
          {activeTab === "recurring" && <RecurringTransactions onBack={() => setActiveTab("home")} onNavigate={handleNavigate} />}
          {activeTab === "sub-accounts" && <SubAccounts onBack={() => setActiveTab("home")} />}
          {activeTab === "settings" && <Settings onBack={() => setActiveTab("home")} />}
          {activeTab === "profile" && <Profile onBack={() => setActiveTab("home")} />}
          {activeTab === "about" && <About onBack={() => setActiveTab("home")} />}
        </div>

        {activeTab !== "cards" &&
         activeTab !== "categories" &&
         activeTab !== "scan-document" &&
         activeTab !== "recurring" &&
         activeTab !== "sub-accounts" &&
         activeTab !== "settings" &&
         activeTab !== "profile" &&
         activeTab !== "about" && (
          <BottomNav activeTab={activeTab} onTabChange={setActiveTab} onAddExpense={() => setShowAddExpense(true)} />
        )}

        {showAddExpense && (
          <AddExpense onClose={() => setShowAddExpense(false)} />
        )}
        
        <ScrollToTop />
      </main>
    </AccountSelectionProvider>
  )
}
